import React from 'react';
import { Button, Popup, VStack } from '@adc/parallax-component-library';
import QrCode, { QrCodeProps } from './QrCode';
import i18n from '../../utilities/i18n';

/**
 * A popup component that displays a QR code for a study that can be scanned by the mobile app.
 * The popup is triggered by a button click and is automatically hidden when clicked outside.
 * @param {QrCodeProps} props - The properties for the QR code popup component.
 * @returns {React.JSX.Element}
 */
export function QrCodePopup({
  studyIdentifier,
  siteIdentifier,
  subjectIdentifier,
  authorizationCode,
  studyKey,
  siteKey,
  subjectKey,
  uploadFrequency,
}: QrCodeProps) {
  return (
    <Popup
      placement="bottom-end"
      content={
        <VStack alignSelf="center">
          <QrCode
            studyIdentifier={studyIdentifier}
            siteIdentifier={siteIdentifier}
            subjectIdentifier={subjectIdentifier}
            authorizationCode={authorizationCode}
            studyKey={studyKey}
            siteKey={siteKey}
            subjectKey={subjectKey}
            uploadFrequency={uploadFrequency}
          />
        </VStack>
      }
      contentPadding={true}
      testID="qr-code-popup"
    >
      <Button
        variant="secondary"
        size="medium"
        label={i18n.t('QrCode.view')}
        onPress={() => {}}
        testID={'qr-code-popup-button'}
        alignStart
      />
    </Popup>
  );
}
